export default {
    manage_createEditDriverStatus_EditTitle: "Edit Driver Status:",
    manage_createEditDriverStatus_CreateTitle: "Create Driver Status",
    manage_createEditDriverStatus_success: "Driver Status was created successfully",
    manage_createEditDriverStatus_success_edit: "Driver Status was updated successfully",
    manage_createEditDriverStatus_duplicatedDriverStatusErrorMessage: "This Driver Status already exists",
    manage_createEditDriverStatus_NameInputLabel: "Name",
    manage_createEditDriverStatus_AccumulateTimeLabel: "Accumulate Time"
}